







import { Component, Vue, Prop } from 'vue-property-decorator';

/**
 * Truncate any text, iif the length of the string exceeds `maxlength`. You can specify the string
 * via either of the following methods.
 *
 * ### Examples
 * #### 1. Using the `text` prop.
 * ```html
 * <TruncateText text="Some looooooooooooong name" maxlength="3" />
 * <!-- Outputs -->
 * "Som..."
 * ```
 *
 * #### 2. Using the default slot.
 * ```html
 * <TruncateText maxlength="3">Some looooooooooooong name</TruncateText>
 * <!-- Outputs -->
 * "Som..."
 * ```
 *
 * NOTE: The default slot has minimal support, i.e. if there are multiple children of this component,
 * it won't be loaded.
 *
 * NOTE: The `default slot` has more preference than the `text` prop.
 */
@Component
export default class TruncatedText extends Vue {
  /**
   * The text to truncate, use this or the default slot to specify text.
   */
  @Prop(String) readonly text!: string|number;
  /**
   * The maxlength of the string. When the given `text` exceeds this length, the
   * text is stripped and `omission` is added to the string.
   */
  @Prop({ default: 40, type: [Number, String] }) readonly maxlength!: string|number;
  /**
   * Omission if the text exceeds the given `maxlength`.
   */
  @Prop({ default: '...' }) readonly omission!: string;

  /**
   * Extract text from either the default slot or the `text` property,
   */
  get textToTruncate () {
    const text = (this.$slots.default?.[0]?.text) || this.text;
    return text === null || text === undefined ? '' : `${text}`;
  }

  get content () {
    const { textToTruncate: str, maxlength, omission } = this;

    return str.length > maxlength ? `${str.substring(0, +maxlength)}${omission}` : str;
  }
}
